var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "layout" }, [
      _c("div", { staticClass: "error-403" }, [
        _c("img", {
          staticClass: "error-403-img",
          attrs: { src: "images/err-403.png" },
        }),
        _c("div", { staticClass: "error-403-text" }, [
          _vm._v("Доступ запрещен. У вас недостаточно прав"),
        ]),
        _c("div", { staticClass: "error-403-link" }, [
          _vm._v(" Обратитесь к администратору системы — "),
          _c("a", { attrs: { href: "mailto:v@doxsw.com" } }, [
            _vm._v("v@doxsw.com"),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }